export default "__VITE_ASSET__CAzFUPl4__"